define('OutSystems/ClientRuntime/Interfaces',["require", "exports", "./modules/Database/AutoNumber", "./modules/Database/DBDataType"], function (require, exports, AutoNumber_1, DBDataType_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.NativeHttp = exports.FeedbackMessage = exports.Model = exports.ClientDB = exports.Application = void 0;
    var Application;
    (function (Application) {
        var InitializationType;
        (function (InitializationType) {
            InitializationType[InitializationType["Full"] = 0] = "Full";
            InitializationType[InitializationType["Minimal"] = 1] = "Minimal";
        })(InitializationType = Application.InitializationType || (Application.InitializationType = {}));
    })(Application = exports.Application || (exports.Application = {}));
    var ClientDB;
    (function (ClientDB) {
        ClientDB.AutoNumber = AutoNumber_1.default;
        ClientDB.DBDataType = DBDataType_1.default;
    })(ClientDB = exports.ClientDB || (exports.ClientDB = {}));
    var Model;
    (function (Model) {
        var DataFetchStatus;
        (function (DataFetchStatus) {
            DataFetchStatus[DataFetchStatus["Fetching"] = 0] = "Fetching";
            DataFetchStatus[DataFetchStatus["Fetched"] = 1] = "Fetched";
            DataFetchStatus[DataFetchStatus["Error"] = 2] = "Error";
        })(DataFetchStatus = Model.DataFetchStatus || (Model.DataFetchStatus = {}));
    })(Model = exports.Model || (exports.Model = {}));
    var FeedbackMessage;
    (function (FeedbackMessage) {
        var FeedbackMessageType;
        (function (FeedbackMessageType) {
            FeedbackMessageType[FeedbackMessageType["Info"] = 0] = "Info";
            FeedbackMessageType[FeedbackMessageType["Success"] = 1] = "Success";
            FeedbackMessageType[FeedbackMessageType["Warning"] = 2] = "Warning";
            FeedbackMessageType[FeedbackMessageType["Error"] = 3] = "Error";
        })(FeedbackMessageType = FeedbackMessage.FeedbackMessageType || (FeedbackMessage.FeedbackMessageType = {}));
    })(FeedbackMessage = exports.FeedbackMessage || (exports.FeedbackMessage = {}));
    var NativeHttp;
    (function (NativeHttp) {
        var NativeHttpRequestReadyState;
        (function (NativeHttpRequestReadyState) {
            NativeHttpRequestReadyState[NativeHttpRequestReadyState["Created"] = 0] = "Created";
            NativeHttpRequestReadyState[NativeHttpRequestReadyState["Sent"] = 1] = "Sent";
            NativeHttpRequestReadyState[NativeHttpRequestReadyState["Receiving"] = 2] = "Receiving";
            NativeHttpRequestReadyState[NativeHttpRequestReadyState["Aborting"] = 3] = "Aborting";
            NativeHttpRequestReadyState[NativeHttpRequestReadyState["Finished"] = 4] = "Finished";
        })(NativeHttpRequestReadyState = NativeHttp.NativeHttpRequestReadyState || (NativeHttp.NativeHttpRequestReadyState = {}));
    })(NativeHttp = exports.NativeHttp || (exports.NativeHttp = {}));
});
//# sourceMappingURL=Interfaces.js.map;
